module.exports = __webpack_public_path__ + "media/images/pic/saska/team/teachers/sonja-gorniak-43d4c6f3322c2e309fedc6e389f09909.png";